<div #headerPos class="tabbable__body rounded-top-right no-margin">
  <h3>Här kan du administrera avancerade målgrupper</h3>

  @if (show.estimatesHaveChanged) {
    <import-warning></import-warning>
  }
  <form #shareOfTotalForm="ngForm">
    <label>
      Andel av totallagret som ska vara tillgängligt för bokningar av avancerade målgrupper
    </label>
    <div class="save-total-lager-container">
      <div class="lager-input">
        <div class="input__container">
          <input
            name="advancedTargetGroupsShareOfTotal"
            [(ngModel)]="shareOfTotal"
            wooPercentFormatter
            [wooMinValidator]="0"
            [wooMaxValidator]="1"
          />
        </div>
      </div>
        <div class="lager-button">
          <button
            class="button primary-1 "
            (click)="updateShareOfTotal()"
            [disabled]="!shareOfTotalForm.valid || saving()"
          >
            Spara 
          </button>
          @if(saving()) {
            <div class="spinner-grow text-danger" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          }
        </div>
    </div>

    <div class="divider margin-top-bottom--2x"></div>

    <div class="container">
      <div class="left-item">
        <button
          class="button primary-1 margin-bottom--1x"
          (click)="showNewTargetGroupForm(true)"
          [disabled]="noAvailableCategories"
          [scrollTo]="newCategoryFormContainer"
        >
          Ny avancerad målgrupp
        </button>
        <button
          class="button primary-1 margin-bottom--1x"
          (click)="showNewCategoryForm(true)"
          [scrollTo]="newTargetGroupFormContainer"
        >
          Ny kategori
        </button>

        @if (isEditing()) {
          <button
            class="button primary"
            (click)="save()"
            [disabled]="advancedTargetGroupValues.invalid || savingTableEdit()"
          >
            Spara
          </button>
          <button class="link" (click)="cancelEditing()">
            Avbryt redigering
          </button>
        } @else {
          <button
            class="button secondary"
            (click)="setEditing(true)"
          >
            Redigera avancerade målgrupper
          </button>
        }
      </div>

      <div class="right-item">
        <div class="dropdown filter-dropdown margin-left--2x">
          <woo-dropdown
            [items]="advancedTargetGroups()"
            [(ngModel)]="selectedAdvancedTargetGroups"
            name="selectedAdvancedTargetGroups()"
            inputId="select-AdvancedTargetGroups"
            labelText="Filtrera på Målgrupp"
            notFoundText="Ingen målgrupp hittades."
            [clearable]="true"
          ></woo-dropdown>
        </div>

        @if (productFormats()?.length > 1) {
          <div class="dropdown filter-dropdown margin-left--2x">
            <woo-dropdown
              [items]="productFormats()"
              [(ngModel)]="selectedProductFormat"
              name="selectedProductFormat()"
              inputId="select-product-format"
              labelText="Filtrera på Placering"
              [labelTransform]="translateProductFormat"
              notFoundText="Inga Placeringar hittades."
              [clearable]="true"
            ></woo-dropdown>
          </div>
        }

        @if (publishers()?.length > 1) {
          <div class="filter-dropdown margin-left--2x">
            <woo-dropdown
              [items]="publishers()"
              [(ngModel)]="selectedPublisher"
              name="selectedPublisher"
              inputId="select-publisher"
              labelText="Filtrera på Publicist"
              notFoundText="Inga publicister hittades."
              [clearable]="true"
            ></woo-dropdown>
          </div>
        }
      </div>
    </div>
  </form>

  <div class="sticky-header">
        <h3>Tillgängliga avancerade målgrupper</h3>
  </div>

  <table
    class="table table-woo table--info table--hover width--100"
    ngForm
    #advancedTargetGroupValues="ngForm"
  >
    <thead class="sticky-table-head">
      <tr>
        <th [colSpan]="staticFields"></th>
        <th class="text-center" colspan="3">Estimatfördelning</th>
        <th class="text-center" colspan="3">Maxuttag</th>
        <th [colSpan]="1"></th>
      </tr>
      <tr>
        @for (header of tableHeaders; track $index) {
          <th class="text--small capitalize--first-letter">
            {{ header }}
          </th>
        }
      </tr>
    </thead>

    @if (!loading()) {
      <tbody>
          @for (
            row of advancedTargetGroupRows();
            track $index;
            let index = $index;
            ) {
            <tr [hidden]="!rowVisible(row)">
              <td class="text--thin vertical-align--middle">
                <span>{{ row.publisher }}</span>
              </td>
              <td class="text--thin vertical-align--middle">
                <span>{{ translateProductFormat(row.productFormat) }}</span>
              </td>
              <td class="text--thin vertical-align--middle">
                <span>{{ row.category }}</span>
              </td>
              <td class="text--thin vertical-align--middle">
                <span>{{ row.tag }}</span>
              </td>
              <td class="text--thin vertical-align--middle">
                <span>{{ row.mrm_id }}</span>
              </td>
              <td class="text--thin vertical-align--middle">
                <span>{{ row.advancedTargetGroupName }}</span>
              </td>
  
              <td class="text--thin vertical-align--middle">
                @if (isEditing()) {
                  <div class="input__container min-input">
                    <toggle
                      name="row-{{ index }}-active"
                      [(ngModel)]="
                        getSpecificAdvancedTargetGroup(row.advancedTargetGroupId)
                          .active
                      "
                    ></toggle>
                  </div>
                } @else {
                  <span>
                    {{
                      getSpecificAdvancedTargetGroup(row.advancedTargetGroupId)
                        .active
                        ? 'Ja'
                        : 'Nej'
                    }}
                  </span>
                }
              </td>
  
              <td class="vertical-align--middle">
                @if (!isEditing()) {
                  <span>{{ row.sharesPreroll | percent: '1.0-3' }}</span>
                } @else {
                  <div class="input__container min-input">
                    <input
                      name="row-{{ index }}-sharesPreroll"
                      [(ngModel)]="
                        getSpecificAdvancedTargetGroupShares(
                          row.advancedTargetGroupId,
                          row.publisherId,
                          row.productFormatId
                        ).preroll
                      "
                      wooPercentFormatter
                      [wooMinValidator]="0"
                      [wooMaxValidator]="1"
                      [required]="
                        includedProductFormatSlotTypes()[row.productFormatId]
                          .preroll
                      "
                      [disabled]="
                        !includedProductFormatSlotTypes()[row.productFormatId]
                          .preroll
                      "
                    />
                  </div>
                }
              </td>
  
              <td class="vertical-align--middle">
                @if (!isEditing()) {
                  <span>{{ row.sharesMidroll | percent: '1.0-3' }}</span>
                } @else {
                  <div class="input__container min-input">
                    <input
                      name="row-{{ index }}-sharesMidroll"
                      [(ngModel)]="
                        getSpecificAdvancedTargetGroupShares(
                          row.advancedTargetGroupId,
                          row.publisherId,
                          row.productFormatId
                        ).midroll
                      "
                      wooPercentFormatter
                      [wooMinValidator]="0"
                      [wooMaxValidator]="1"
                      [required]="
                        includedProductFormatSlotTypes()[row.productFormatId]
                          .midroll
                      "
                      [disabled]="
                        !includedProductFormatSlotTypes()[row.productFormatId]
                          .midroll
                      "
                    />
                  </div>
                }
              </td>
  
              <td class="vertical-align--middle">
                @if (!isEditing()) {
                  <span>{{ row.sharesPostroll | percent: '1.0-3' }}</span>
                } @else {
                  <div class="input__container min-input">
                    <input
                      name="row-{{ index }}-sharesPostroll"
                      [(ngModel)]="
                        getSpecificAdvancedTargetGroupShares(
                          row.advancedTargetGroupId,
                          row.publisherId,
                          row.productFormatId
                        ).postroll
                      "
                      wooPercentFormatter
                      [wooMinValidator]="0"
                      [wooMaxValidator]="1"
                      [required]="
                        includedProductFormatSlotTypes()[row.productFormatId]
                          .postroll
                      "
                      [disabled]="
                        !includedProductFormatSlotTypes()[row.productFormatId]
                          .postroll
                      "
                    />
                  </div>
                }
              </td>
  
              <td class="vertical-align--middle">
                @if (!isEditing()) {
                  <span>{{ row.withdrawalLimitsPreroll | percent: '1.0-3' }}</span>
                } @else {
                  <div class="input__container min-input">
                    <input
                      name="row-{{ index }}-limitsPreroll"
                      [(ngModel)]="
                        getSpecificAdvancedTargetGroupLimits(
                          row.advancedTargetGroupId,
                          row.publisherId,
                          row.productFormatId
                        ).preroll
                      "
                      wooPercentFormatter
                      [wooMinValidator]="0"
                      [wooMaxValidator]="1"
                      [required]="
                        includedProductFormatSlotTypes()[row.productFormatId]
                          .preroll
                      "
                      [disabled]="
                        !includedProductFormatSlotTypes()[row.productFormatId]
                          .preroll
                      "
                    />
                  </div>
                }
              </td>
  
              <td class="vertical-align--middle">
                @if (!isEditing()) {
                  <span>{{ row.withdrawalLimitsMidroll | percent: '1.0-3' }}</span>
                } @else {
                  <div class="input__container min-input">
                    <input
                      name="row-{{ index }}-limitsMidroll"
                      [(ngModel)]="
                        getSpecificAdvancedTargetGroupLimits(
                          row.advancedTargetGroupId,
                          row.publisherId,
                          row.productFormatId
                        ).midroll
                      "
                      wooPercentFormatter
                      [wooMinValidator]="0"
                      [wooMaxValidator]="1"
                      [required]="
                        includedProductFormatSlotTypes()[row.productFormatId]
                          .midroll
                      "
                      [disabled]="
                        !includedProductFormatSlotTypes()[row.productFormatId]
                          .midroll
                      "
                    />
                  </div>
                }
              </td>
  
              <td class="vertical-align--middle">
                @if (!isEditing()) {
                  <span>{{ row.withdrawalLimitsPostroll | percent: '1.0-3' }}</span>
                } @else {
                  <div class="input__container min-input">
                    <input
                      name="row-{{ index }}-limitsPostroll"
                      [(ngModel)]="
                        getSpecificAdvancedTargetGroupLimits(
                          row.advancedTargetGroupId,
                          row.publisherId,
                          row.productFormatId
                        ).postroll
                      "
                      wooPercentFormatter
                      [wooMinValidator]="0"
                      [wooMaxValidator]="1"
                      [required]="
                        includedProductFormatSlotTypes()[row.productFormatId]
                          .postroll
                      "
                      [disabled]="
                        !includedProductFormatSlotTypes()[row.productFormatId]
                          .postroll
                      "
                    />
                  </div>
                }
              </td>
  
              <td class="padding-top-bottom--1x">
                <button
                  [routerLink]="[
                    '/advanced_target_groups',
                    row.advancedTargetGroupId
                  ]"
                  class="status-badge primary float--left"
                >
                  <span class="icon-edit icon__semi-medium"></span>
                </button>
              </td>
            </tr>
          }

      </tbody>
    }


  </table>
  @if (isEditing()) {
    <div class="margin-top-bottom--2x">
        <button
          class="button primary"
          (click)="save()"
          [disabled]="advancedTargetGroupValues.invalid || savingTableEdit()"
        >
        Spara
      </button>
      <button class="link" (click)="cancelEditing()">
        Avbryt redigering
      </button>
    </div>
  }
  <dot-loader [visibility]="loading()" [large]="true"></dot-loader>  

  <div #newCategoryFormContainer>
    @if (show.newCategoryForm) {
      <div class="sub-card col-12">
        <h3>Ny avancerad målgruppskategori</h3>
        <advanced-target-group-category-form
          [categories]="categories()"
          (onCreated)="setCategories()"
          (onClose)="showNewCategoryForm(false)"
        ></advanced-target-group-category-form>
      </div>
    }
  </div>

  <div #newTargetGroupFormContainer>
    @if (show.newTargetGroupForm) {
      <div class="sub-card col-12">
        <h3>Ny avancerad målgrupp</h3>
        <advanced-target-group-form
          [categories]="categories()"
          (onAbort)="showNewTargetGroupForm(false, headerPos)"
          (onSubmit)="addAdvancedTargetGroup($event)"
        ></advanced-target-group-form>
      </div>
    }
  </div>
</div>

